import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import DateFormat from '../common/dateFormat/DateFormat';

import {
	setModoTela, initFormExecucao
} from './ordemServicoActions';


class OrdemServicoExecucaoForm extends Component {

	state = {

	}

	componentWillMount() {

	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='descricao_execucao'
								component={LabelAndInput}
								label='Descrição a mais na não conformidade que o motorista observou' placeholder='Informe a descrição'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='observacao_execucao'
								component={LabelAndInput}
								label='Detalhes do responsável sobre a manutenção' placeholder='Informe os Detalhes'
								cols='12 12 12 12'
								readOnly={readOnly} />

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										disabled={this.props.negociacao}
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('cadastro', this.props.registro)} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		)
	}


}

OrdemServicoExecucaoForm = reduxForm({ form: 'ordemServicoExecucaoForm', destroyOnUnmount: false })(OrdemServicoExecucaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	formularioValues: getFormValues('ordemServicoExecucaoForm')(state),
	registro: state.ordemServico.registro,
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initFormExecucao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(OrdemServicoExecucaoForm);
